/**
 * NS shadow tokens — centralized named exports voor `var(--ns-shadow-*)`
 * CSS-custom-property references.
 *
 * M5b (PR 469097 review): voorheen werd `'var(--ns-shadow-elevated-2)'` 23x
 * herhaald in `theme.ts` NS_SHADOWS tuple (en als losse literal in
 * `components/card/mui-paper-overrides.ts` +
 * `plugins/app-module-navigation/src/components/sidebar-item/backstage-sidebar-item-overrides.ts`).
 * Single source of truth voorkomt
 * dat een token-rename in tokens.css op meerdere plaatsen handmatig
 * gesynchroniseerd moet worden.
 *
 * Token-bron: `./tokens.css` (light + dark variants).
 */

export const NS_SHADOW_ELEVATED_1 = 'var(--ns-shadow-elevated-1)';
export const NS_SHADOW_ELEVATED_2 = 'var(--ns-shadow-elevated-2)';
